// extracted by mini-css-extract-plugin
export default {"root":"style_root__m4PxL","header":"style_header__W8E0A","title":"style_title__RUVdK"};